<template>
  <v-app>
    <v-carousel hide-delimiters :show-arrows="false" height="300">
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
      >
        <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <div class="display-3 d-none d-md-block">Rastrea tu Pedido</div>
          </v-row>
      </v-carousel-item>
    </v-carousel>
    <div>
      <v-row no-gutters>
        <v-col
          align-self="center"
        >
          <v-card
            class="pa-2"
            flat
          >
            <p class="title text-center">Rastrea tu pedido en Tiempo Real aquí!</p>
            <p class="text-center">
              <v-icon x-large color="orange">mdi-pizza</v-icon>
            </p>
            <v-form ref="search_form" v-on:submit.prevent="searchOrder">
              <v-text-field
                label="Número de Orden"
                clearable
                append-outer-icon="search"
                v-model="order_num"
                :rules="required"
                required
                @click:append-outer="searchOrder"
              ></v-text-field>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="searchingOrder">
        <v-col sm="12" class="text-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="black"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-if="orderData.length > 0 && !searchingOrder">
        <v-col sm="12" class="text-center">
          <v-card
            flat
          >
            <v-card-text class="py-0">
              <v-timeline
                align-top
                dense
              >
                <v-timeline-item
                  color="success"
                  small
                  v-for="(item, i) in orderData"
                  :key="i"
                  icon="mdi-pizza"
                >
                  <v-row class="pt-1">
                    <v-col cols="3">
                      <strong>{{format(parseISO(item.fecha), 'HH:mm dd/MM/yy')}}</strong>
                    </v-col>
                    <v-col>
                      <strong>{{item.status}}</strong>
                      <div class="caption">Status</div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="notFound">
        <v-col class="text-center">
          <p class="title">Orden Incorrecta!</p>
          <v-icon x-large color="error">far fa-grin-tongue</v-icon>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>

<script>
import axios from 'axios'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

import Pusher from 'pusher-js' // import Pusher

const pusher = new Pusher('a3066e9e2d1ba9dbb8a4', { cluster: 'us3' })
const channel = pusher.subscribe('orders')

export default {
    name: 'Tracking',
    data() {
      return {
        format,
        parseISO,
        items: [
          {
            src: require('../assets/hero1.jpg'),
          }
        ],
        order_num: null,
        required: [
          v => !!v || 'Campo Requerido'
        ],
        searchingOrder: false,
        orderData: [],
        notFound: false
      }
    },
    created() {
      
    },
    methods: {
      searchOrder() {
        this.notFound = false
        if(this.$refs.search_form.validate()) {
          this.searchingOrder = true
          console.log(this.order_num)
          axios.get(this.$store.state.astilleroURL + '/api/views/services_order_tracking?display_id=services_1&args[0]=' + this.order_num)
          .then(res => {
            console.log(res.data)
            this.searchingOrder = false
            this.orderData = res.data
            if(res.data.length == 0) {
              this.notFound = true
            }
            else {
              this.pusherSubscriber(this.order_num)
            }
          })
          .catch(error => {
            this.searchingOrder = false
          })
        }
      },
      reLoadActivities(order) {
        console.log('Reloading Activities')
        axios.get(this.$store.state.astilleroURL + '/api/views/services_order_tracking?display_id=services_1&args[0]=' + order)
        .then(res => {
          this.orderData = res.data
          console.log('Activities Reloaded')
        })
        .catch(error => console.log(error))
      },
      pusherSubscriber(order_num) {
        console.log('Subscribed to Order: ' + order_num)
        channel.bind('order-' + order_num, data => {
          //Reload Activities
          this.reLoadActivities(order_num)
        })
      },
    }
}
</script>

<style>

</style>